// extracted by mini-css-extract-plugin
module.exports = {"NavBar":"NavBar_NavBar__c6zD5","DesktopOnly":"NavBar_DesktopOnly__SxTSY","MobileOnly":"NavBar_MobileOnly__qX6fq"};